// extracted by mini-css-extract-plugin
export default {"h2":"Table_h2__JWXj4","content":"Table_content__fwNYZ","green":"Table_green__l7FoU","red":"Table_red__6LRGx","font":"Table_font__6ReCs"};